import { trackingAxios } from 'config/api/tracking'
import { IProviderRepository } from '../domain/repositories/IProviderRepository'
import { Provider } from '../domain/entities/Provider'

interface ApiProviderResponse {
  id: number
  name: string
  code: string
}

interface ProvidersApiResponse {
  error: boolean
  data: ApiProviderResponse[]
}

export class AxiosProviderRepository implements IProviderRepository {
  async getProviders(countryCode?: string): Promise<Provider[]> {
    try {
      const params = countryCode ? { country_code: countryCode } : {}
      
      const response = await trackingAxios.get<ProvidersApiResponse>('/externals/providers', {
        params
      })
      
      return response.data.data.map((provider) => ({
        id: provider.id,
        code: provider.code,
        name: provider.name,
      }))
    } catch (error) {
      console.error('[AxiosProviderRepository] Error fetching providers:', error)
      throw error
    }
  }
}